<section class="hd-awareness-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-awareness-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-awareness-cheat-sheet-page__controls" aria-label="Awareness cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-awareness-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-awareness-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-awareness-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }
  @if (pageSubtitle()) {
    <p class="hd-awareness-cheat-sheet-page__subtitle">{{ pageSubtitle() }}</p>
  }

  <div class="hd-awareness-cheat-sheet-page__deck">
    @for (section of sections(); track section.key) {
      <article class="aw-section"
               [class.aw-section--triangle-left]="section.trianglePlacement === 'left'"
               [class.aw-section--stair-tent]="section.staircase === 'tent'"
               [class.aw-section--stair-valley]="section.staircase === 'valley'">
        <!-- Centrum-beschrijving (+ Algemeen onder Solar Plexus) -->
        <div class="aw-section__aside">
          @if (section.title) {
            <h3 class="aw-section__heading">{{ section.title }}</h3>
          }
          @for (para of section.description; track $index) {
            <p class="aw-section__text">{{ para }}</p>
          }
          @if (section.extraTitle) {
            <h3 class="aw-section__heading aw-section__heading--extra">{{ section.extraTitle }}</h3>
          }
          @for (para of section.extraDescription; track $index) {
            <p class="aw-section__text">{{ para }}</p>
          }
        </div>

        <!-- Poort-angstkaarten (gedeeld blokje, ook gebruikt in de fear-info-panelen) -->
        <div class="aw-section__cards">
          @for (gate of section.gates; track gate) {
            <hd-fear-card [gate]="gate" />
          }
        </div>

        <!-- Driehoek-diagram van het bewustzijnscentrum -->
        <div class="aw-section__triangle">
          <img class="aw-section__triangle-image" [src]="section.triangleImage" [alt]="section.triangleAlt" />
        </div>
      </article>
    }
  </div>
</section>
